
import Vue, { PropType } from "vue";
import { UserActiveCoupon } from "@prestonly/preston-common";

import { DialogCloseType, DialogI } from "@/types/dialog";
import BaseDialog from "@/components/dialog/BaseDialog.vue";
import Btn from "@/components/v2/base/Btn.vue";
import NextLessonButton from "@/components/onboarding/NextLessonButton.vue";
import { PlanReward } from "@/store/modules/onboarding";
import { communicatedCouponExpiry } from "@/utils/accessOffer";
import { maybeRequestStoreReview } from "@/utils/storeReview";

interface PlanTrophyPayload {
  steps: number;
  sentences: number;
  days: number;
  reward: PlanReward | null;
  /** The course's next lesson after the plan; null when the course is finished. */
  nextLesson: { lessonId: string; name: string } | null;
}

/**
 * Etap 13: the last stamp of the weekly plan. Shown instead of the lesson summary when the
 * finished lesson closes the plan; the trophy reveals the coupon (trial) and leads on to the course's next lesson.
 */
export default Vue.extend({
  name: "PlanTrophyDialog",
  components: { BaseDialog, Btn, NextLessonButton },
  props: {
    dialog: {
      type: Object as PropType<DialogI>,
      required: true,
    },
  },
  computed: {
    payload(): PlanTrophyPayload {
      return this.dialog.config.payload as PlanTrophyPayload;
    },
    coupon(): UserActiveCoupon | null {
      return this.payload.reward?.kind === "coupon" ? this.payload.reward.coupon : null;
    },
    unlock(): boolean {
      return this.payload.reward?.kind === "none";
    },
    couponExpiry(): string {
      return this.coupon ? communicatedCouponExpiry(this.coupon).format("D.MM") : "";
    },
  },
  methods: {
    closeWith(action: "claim" | "courses" | "next-lesson"): void {
      this.dialog.close({ type: DialogCloseType.SUBMITTED, payload: { action } });
      // A finished plan is a win worth a store rating, but only on the way back to the course
      // list: "claim" opens the offer, and "next-lesson" starts a lesson the app won't interrupt.
      if (action === "courses") maybeRequestStoreReview("plan_finished");
    },
  },
});
